import { formatDate } from "vue2-element-dict"
export default {
  computed: {
    mixinUserInfo() {
      return this.$store.getters.userInfo
    },
    mixinFileServer() {
      return this.$store.getters.systemConfig?.fileServer || ""
    },
    // 叶子仓库id
    mixinWareHouseIdList() {
      return this.$store.getters.wareHouseIdList
    },
    // 包含父级的权限仓库列表
    mixinPermiWareHouseIds() {
      return this.$store.getters.permiWareHouseIds
    }
  },
  methods: {
    // 表单重置
    mixinResetForm(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields()
      }
    },

    // 添加日期范围
    mixinAddDateRange(
      params,
      dateRange,
      datePickerType = "daterange",
      propName = "Time"
    ) {
      dateRange = Array.isArray(dateRange) ? dateRange : []
      params["begin" + propName] = dateRange[0] || ""
      params["end" + propName] = dateRange[1] || ""

      //如果是日期范围（无具体时间点），endTime 加一天
      if (datePickerType === "daterange" && dateRange[1]) {
        const date = formatDate(
          new Date(dateRange[1]).getTime() + (1000 * 60 * 60 * 24 - 1),
          "datetime"
        )
        params["end" + propName] = date
      }

      return params
    },
    // 根据权限数组判定是否有权限
    mixinHasPermi(permiArr) {
      return this.$store.getters.permissionList.some((item) => {
        return permiArr.includes(item)
      })
    },
    // 按钮去除聚焦
    mixinBtnBlur() {
      let target = event.target
      if (target.nodeName === "SPAN" || target.nodeName === "I") {
        target = event.target.parentNode
      }
      target.blur()
    },

    // 判断是否为 URL 链接
    mixinIsUrl(str) {
      try {
        if (str.includes("https://") || str.includes("http://")) {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    // 返回图片地址
    mixinGetImg(img) {
      if (!img) {
        return ""
      }
      if (this.mixinIsUrl(img)) {
        return img
      }
      return this.mixinFileServer + img
    },
    // 预览
    mixinHandlePreview(img, index = 0) {
      if (!img) {
        return
      }
      if (Array.isArray(img)) {
        const imgList = img.map((item) => {
          let newItem = item
          if (!this.mixinIsUrl(item)) {
            newItem = this.mixinFileServer + newItem
          }
          return newItem
        })
        this.$xiaobuImgPreview({
          clickMaskCLose: true, // 点击遮罩关闭预览
          multiple: true, // 开启多图预览模式
          nowImgIndex: index, // 多图预览，
          imgList // 需要预览的多图数组
        })
      } else {
        let newImg = img
        if (!this.mixinIsUrl(img)) {
          newImg = this.mixinFileServer + newImg
        }
        this.$xiaobuImgPreview({
          clickMaskCLose: true, // 点击遮罩关闭预览
          url: newImg // 单图预览
        })
      }
    },
    // 跳转库存记录
    mixinHandleGoRecordList(operateNo) {
      if (!operateNo) {
        return
      }
      this.$router.push({
        name: "inventoryRecordManage",
        query: {
          operateNo
        }
      })
    },

    // 解决遮罩问题
    mixinRemoveAndAddMask() {
      // 关闭前调整遮罩层
      const masks = document.querySelectorAll("body > .v-modal")
      const target = masks[masks.length - 1]
      // 移除
      target && document.body.removeChild(target)
      target && this.$el.parentElement.appendChild(target)
    },
    // 返回仓库状态的类型
    mixinJudgeWareHouseTypeFun(val) {
      const obj = {
        0: "success",
        1: "success",
        2: "primary",
        3: "warning",
        4: "danger",
        5: "danger"
      }
      return obj[val]
    }
  }
}
